export const landingMarkup = String.raw`<div class="landing-page-container1">
        <div class="landing-page-header1">
          <div class="landing-page-heading10">
            <navbar-wrapper class="navbar-wrapper">
              <!--Navbar component-->
              <nav class="navbar-navbar">
                <div class="navbar-desktop">
                  <div class="navbar-main">
                    <div class="navbar-branding">
                      <h1 class="navbar-text1"><span>surfslot</span></h1>
                    </div>
                    <div class="navbar-links1">
                      <a href="#features" class="navbar-link1 link">Features</a>
                      <a href="#faq" class="navbar-link2 link">
                        <span>How it works</span>
                      </a>
                      <a href="#pricing" class="navbar-link3 link">
                        <span>Prices</span>
                      </a>
                      <a
                        href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Contact Form"
                        class="navbar-link4 link"
                      >
                        <span>Contact</span>
                      </a>
                    </div>
                  </div>
                  <div class="navbar-quick-actions">
                    <a href="/" class="navbar-navlink1">
                      <div
                        loginwithgoogle=""
                        class="navbar-sign-up-btn google-login"
                      >
                        <span loginwithgoogle=""><span>Sign Up</span></span>
                      </div>
                    </a>
                  </div>
                </div>
                <div id="mobile-menu" class="navbar-mobile">
                  <div class="navbar-top">
                    <img
                      alt="image"
                      src="/landing/pastedimage-cx4wqj.svg"
                      class="navbar-image"
                    />
                    <svg
                      id="close-mobile-menu"
                      viewBox="0 0 1024 1024"
                      class="navbar-icon1"
                    >
                      <path
                        d="M810 274l-238 238 238 238-60 60-238-238-238 238-60-60 238-238-238-238 60-60 238 238 238-238z"
                      ></path>
                    </svg>
                  </div>
                  <div class="navbar-links2">
                    <a href="#features" class="navbar-navlink2">
                      <span>Features</span>
                    </a>
                    <a href="#how-it-works" class="navbar-navlink3">
                      <span>How it works</span>
                    </a>
                    <a href="#pricing" class="navbar-navlink4">
                      <span>Prices</span>
                    </a>
                    <a href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Contact Form" class="navbar-navlink5">
                      <span>Contact</span>
                    </a>
                    <div class="navbar-buttons">
                      <a href="/" class="navbar-navlink6">
                        <div loginwithgoogle="" class="navbar-btn1">
                          <span class="navbar-text3"><span>Log in</span></span>
                        </div>
                      </a>
                      <a href="/" class="navbar-navlink7">
                        <div loginwithgoogle="" class="navbar-btn2">
                          <span class="navbar-text4"><span>Sign up</span></span>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </nav>
            </navbar-wrapper>
          </div>
          <div class="landing-page-hero">
            <div class="landing-page-content1">
              <h1 class="landing-page-title1">
                <span>do not lose that surf session</span>
                <span class="landing-page-text11">in <br /><span data-location-text="">Ericeira</span>&nbsp;</span>
              </h1>
              <span class="landing-page-caption1">
                <span>
                  SurfSlot is your scheduling automation platform for
                  eliminating the great days of surf that you loose by having
                  conflicting meetings.
                </span>
                <br />
              </span>
              <div loginwithgoogle="" class="landing-page-android-btn1">
                <caption-wrapper class="caption-wrapper">
                  <!--Caption component-->
                  <div class="caption-container">
                    <span class="caption-caption">
                      <span>Sign in with Google</span>
                    </span>
                  </div>
                </caption-wrapper>
                <img
                  alt="image"
                  src="/landing/google-logo-png-suite-everything-you-need-know-about-google-newest-0-200h.png"
                  class="landing-page-image1"
                />
              </div>
            </div>
            <img
              alt="image"
              src="/landing/1-png-aef2a3%20%5B1%5D-800h.jpg"
              class="landing-page-image2"
            />
          </div>
        </div>
        <div id="how-it-works" class="landing-page-video">
          <div class="landing-page-content2">
            <div class="landing-page-header2">
              <h2 class="landing-page-text14">
                Built specifically for people who have important meetings (with
                the ocean)
              </h2>
            </div>
            <div class="landing-page-video-container">
              <img
                alt="image"
                src="/landing/frame%2049-600h.png"
                loading="eager"
                class="landing-page-image3"
              />
              <div class="landing-page-heading-container">
                <div class="landing-page-heading11">
                  <span class="landing-page-text15">
                    <span>
                      Avoid having your team mates scheduling meetings when it
                      is good to surf
                    </span>
                    <span class="landing-page-text17">in <span data-location-text="">Ericeira</span></span>
                    <span>.&nbsp;</span>
                  </span>
                  <span class="landing-page-text19">
                    Spreadsheets can wait, the tide can't.&nbsp;
                  </span>
                </div>
                <div class="landing-page-explore1">
                  <a href="#pricing" class="landing-page-link1">
                    Explore pricing plans -&gt;
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="landing-page-stats">
          <div class="landing-page-stat1">
            <span class="landing-page-caption2">200k</span>
            <span class="landing-page-description1">
              <span>waves that are not surfed</span>
              <!-- <span class="landing-page-text21">in <span data-location-text="">Ericeira</span></span> -->
              <span>because of conflicting meetings</span>
            </span>
          </div>
          <div class="landing-page-stat2">
            <span class="landing-page-caption3">5 meetings</span>
            <span class="landing-page-description2">
              per week that can be done earlier or afterwards. Or even more
            </span>
          </div>
          <div class="landing-page-stat3">
            <span class="landing-page-caption4">10 meetings</span>
            <span class="landing-page-description3">
              per week that you are attending but your focus is on the forecast
              &nbsp;
            </span>
          </div>
        </div>
        <div id="features" class="landing-page-features">
          <div class="landing-page-header3">
            <div class="landing-page-tag1">
              <span class="landing-page-text23">Features</span>
            </div>
            <div class="landing-page-heading12">
              <h2 class="landing-page-text24">
                Everything you get with surfslot
              </h2>
              <span class="landing-page-text25">
                <span>
                  We are building surfslot, the main functionality is completed
                </span>
                <span class="landing-page-text27"></span>
                <span class="landing-page-text28">to ericeira</span>
                <span>
                  but reach out to us if you have ideas on how to improve it (or
                  if you would like to have it on your location).
                </span>
              </span>
            </div>
          </div>
          <div class="landing-page-feature-list">
            <feature-wrapper class="feature-wrapper">
              <!--Feature component-->
              <div class="feature-feature feature">
                <img
                  alt="image"
                  src="/landing/vector.svg"
                  class="feature-image"
                />
                <div class="feature-content">
                  <span class="feature-title"><span>Account</span></span>
                  <span class="feature-description">
                    <span>
                      Your own account customised to your surfing plans
                    </span>
                  </span>
                </div>
              </div>
            </feature-wrapper>
            <feature-wrapper-5qpj class="feature-wrapper-5qpj">
              <!--Feature component-->
              <div class="feature-feature1 feature">
                <img
                  alt="image"
                  src="/landing/vector6113-6zj.svg"
                  class="feature-image1"
                />
                <div class="feature-content1">
                  <span class="feature-title1">
                    <span>Accurate Forecasts</span>
                  </span>
                  <span class="feature-description1">
                    <span>
                      We feed our scheduling agent with the best surfing
                      forecasts
                    </span>
                  </span>
                </div>
              </div>
            </feature-wrapper-5qpj>
            <feature-wrapper-cyw9 class="feature-wrapper-cyw9">
              <!--Feature component-->
              <div class="feature-feature2 feature">
                <img
                  alt="image"
                  src="/landing/vector6114-cupp.svg"
                  class="feature-image2"
                />
                <div class="feature-content2">
                  <span class="feature-title2">
                    <span>Google Calendar</span>
                  </span>
                  <span class="feature-description2">
                    <span>
                      The application is fully integrated with Google Calendar
                    </span>
                  </span>
                </div>
              </div>
            </feature-wrapper-cyw9>
            <feature-wrapper-vdfz class="feature-wrapper-vdfz">
              <!--Feature component-->
              <div class="feature-feature3 feature">
                <img
                  alt="image"
                  src="/landing/vector6113-r6dl.svg"
                  class="feature-image3"
                />
                <div class="feature-content3">
                  <span class="feature-title3">
                    <span>Multiple Devices</span>
                  </span>
                  <span class="feature-description3">
                    <span>
                      Web application that is web based (but you can used it on
                      mobile)
                    </span>
                  </span>
                </div>
              </div>
            </feature-wrapper-vdfz>
          </div>
        </div>
        <div id="pricing" class="landing-page-pricing">
          <div class="landing-page-content3">
            <div class="landing-page-header4">
              <div class="landing-page-tag2">
                <span class="landing-page-text30">Pricing plans</span>
              </div>
              <div class="landing-page-heading13">
                <h2 class="landing-page-text31">
                  No setup cost or hidden fees.
                </h2>
              </div>
            </div>
            <div class="landing-page-pricing-plans">
              <div class="landing-page-plans1">
                <div class="landing-page-plan1">
                  <div class="landing-page-top1">
                    <div class="landing-page-heading14">
                      <span class="landing-page-text32">
                        <span>Standard</span>
                        <br />
                      </span>
                      <span class="landing-page-text35">
                        <span class="landing-page-text36">
                          Standard plan for busy surfers for the price of a surf
                          wax
                        </span>
                        <br />
                      </span>
                    </div>
                    <div class="landing-page-cost1">
                      <div class="landing-page-cost2">
                        <span class="landing-page-text38">€3.5</span>
                        <span class="landing-page-text39">/month</span>
                      </div>
                    </div>
                  </div>
                  <div class="landing-page-bottom1">
                    <div class="landing-page-check-list1">
                      <check-wrapper class="check-wrapper">
                        <!--Check component-->
                        <div class="check-check check">
                          <svg viewBox="0 0 1024 1024" class="check-icon1">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text">
                            <span>Sync with your Google Calendar</span>
                          </span>
                        </div>
                      </check-wrapper>
                      <check-wrapper-xtl6 class="check-wrapper-xtl6">
                        <!--Check component-->
                        <div class="check-check1 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon3">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text1">
                            <span>Choose your favourite spots</span>
                          </span>
                        </div>
                      </check-wrapper-xtl6>
                      <check-wrapper-sal6 class="check-wrapper-sal6">
                        <!--Check component-->
                        <div class="check-check2 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon5">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text2">
                            <span>Configure your location</span>
                          </span>
                        </div>
                      </check-wrapper-sal6>
                      <check-wrapper-dyvu class="check-wrapper-dyvu">
                        <!--Check component-->
                        <div class="check-check3 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon7">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text3">
                            <span>surfslots into your Google Calendar</span>
                          </span>
                        </div>
                      </check-wrapper-dyvu>
                    </div>
                    <div
                      loginwithgoogle=""
                      class="landing-page-button1 google-login"
                    >
                      <span class="landing-page-text40">Get surfslot</span>
                    </div>
                  </div>
                </div>
                <div class="landing-page-plan2">
                  <div class="landing-page-top2">
                    <div class="landing-page-heading15">
                      <span class="landing-page-text41">Surfers' Business</span>
                      <span class="landing-page-text42">
                        Plan for businesses and teams of surfers
                      </span>
                    </div>
                    <div class="landing-page-cost3">
                      <span class="landing-page-text43">
                        Personalised pricing
                      </span>
                    </div>
                  </div>
                  <div class="landing-page-bottom2">
                    <div class="landing-page-check-list2">
                      <check-wrapper-lwko class="check-wrapper-lwko">
                        <!--Check component-->
                        <div class="check-check4 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon9">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text4">
                            <span>Sync with your Google Calendar</span>
                          </span>
                        </div>
                      </check-wrapper-lwko>
                      <check-wrapper-zorm class="check-wrapper-zorm">
                        <!--Check component-->
                        <div class="check-check5 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon11">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text5">
                            <span>Specify your availability</span>
                          </span>
                        </div>
                      </check-wrapper-zorm>
                      <check-wrapper-sl99 class="check-wrapper-sl99">
                        <!--Check component-->
                        <div class="check-check6 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon13">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text6">
                            <span>Configure your location</span>
                          </span>
                        </div>
                      </check-wrapper-sl99>
                      <check-wrapper-cgrd class="check-wrapper-cgrd">
                        <!--Check component-->
                        <div class="check-check7 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon15">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text7">
                            <span>
                              Rename the events on your employee calendar
                            </span>
                          </span>
                        </div>
                      </check-wrapper-cgrd>
                      <check-wrapper-podo class="check-wrapper-podo">
                        <!--Check component-->
                        <div class="check-check8 check">
                          <svg viewBox="0 0 1024 1024" class="check-icon17">
                            <path
                              d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                            ></path>
                          </svg>
                          <span class="check-text8">
                            <span>
                              Get a special price for several accounts
                            </span>
                          </span>
                        </div>
                      </check-wrapper-podo>
                    </div>
                    <a
                      href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Let's Discuss it"
                      class="landing-page-link2"
                    >
                      <div class="landing-page-button2">
                        <span class="landing-page-text44">
                          Let's discuss it
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
              </div>
              <div class="landing-page-expand1">
                <div class="landing-page-overlay1">
                  <div class="landing-page-header5">
                    <div class="landing-page-heading16">
                      <span class="landing-page-text45">Expand</span>
                      <span class="landing-page-text46">
                        This is simple, no one needs to expand. In case you want
                        to partner with us, we are more than happy to discuss
                        collaboration opportunities&nbsp;
                      </span>
                    </div>
                  </div>
                  <a
                    href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Contact Form"
                    class="landing-page-link3"
                  >
                    <div class="landing-page-button3">
                      <span class="landing-page-text47">
                        <span>Contact us</span>
                        <br />
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
            <div class="landing-page-plans2">
              <div class="landing-page-plan3">
                <div class="landing-page-top3">
                  <div class="landing-page-heading17">
                    <span class="landing-page-text50">Standard</span>
                    <span class="landing-page-text51">
                      Standard plan for busy surfers for the price of a surf wax
                    </span>
                  </div>
                  <div class="landing-page-cost4">
                    <div class="landing-page-cost5">
                      <span class="landing-page-text52">€3.5</span>
                      <span class="landing-page-text53">/month</span>
                    </div>
                  </div>
                </div>
                <div class="landing-page-bottom3">
                  <div class="landing-page-check-list3">
                    <check-wrapper-54hv class="check-wrapper-54hv">
                      <!--Check component-->
                      <div class="check-check9 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon19">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text9">
                          <span>Sync with your Google Calendar</span>
                        </span>
                      </div>
                    </check-wrapper-54hv>
                    <check-wrapper-3vwf class="check-wrapper-3vwf">
                      <!--Check component-->
                      <div class="check-check10 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon21">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text10">
                          <span>Choose your favourite spots</span>
                        </span>
                      </div>
                    </check-wrapper-3vwf>
                    <check-wrapper-glv7 class="check-wrapper-glv7">
                      <!--Check component-->
                      <div class="check-check11 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon23">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text11">
                          <span>Configure your location</span>
                        </span>
                      </div>
                    </check-wrapper-glv7>
                    <check-wrapper-ybt7 class="check-wrapper-ybt7">
                      <!--Check component-->
                      <div class="check-check12 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon25">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text12">
                          <span>
                            surfslots populated into your Google Calendar
                          </span>
                        </span>
                      </div>
                    </check-wrapper-ybt7>
                  </div>
                  <div loginwithgoogle="" class="landing-page-button4">
                    <span class="landing-page-text54">Get surfslot</span>
                  </div>
                </div>
              </div>
              <div class="landing-page-plan4">
                <div class="landing-page-top4">
                  <div class="landing-page-heading18">
                    <span class="landing-page-text55">Surfers' Business</span>
                    <span class="landing-page-text56">
                      Plan for businesses and teams of surfers
                    </span>
                  </div>
                  <div class="landing-page-cost6">
                    <span class="landing-page-text57">
                      Personalised pricing
                    </span>
                  </div>
                </div>
                <div class="landing-page-bottom4">
                  <div class="landing-page-check-list4">
                    <check-wrapper-22hk class="check-wrapper-22hk">
                      <!--Check component-->
                      <div class="check-check13 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon27">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text13">
                          <span>Sync with your Google Calendar</span>
                        </span>
                      </div>
                    </check-wrapper-22hk>
                    <check-wrapper-3880 class="check-wrapper-3880">
                      <!--Check component-->
                      <div class="check-check14 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon29">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text14">
                          <span>Specify your availability</span>
                        </span>
                      </div>
                    </check-wrapper-3880>
                    <check-wrapper-kcsh class="check-wrapper-kcsh">
                      <!--Check component-->
                      <div class="check-check15 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon31">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text15">
                          <span>Configure your location</span>
                        </span>
                      </div>
                    </check-wrapper-kcsh>
                    <check-wrapper-gvk3 class="check-wrapper-gvk3">
                      <!--Check component-->
                      <div class="check-check16 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon33">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text16">
                          <span>
                            Rename the events on your employee calendar
                          </span>
                        </span>
                      </div>
                    </check-wrapper-gvk3>
                    <check-wrapper-qwku class="check-wrapper-qwku">
                      <!--Check component-->
                      <div class="check-check17 check">
                        <svg viewBox="0 0 1024 1024" class="check-icon35">
                          <path
                            d="M384 690l452-452 60 60-512 512-238-238 60-60z"
                          ></path>
                        </svg>
                        <span class="check-text17">
                          <span>Get a special price for several accounts</span>
                        </span>
                      </div>
                    </check-wrapper-qwku>
                  </div>
                  <div class="landing-page-button5">
                    <span class="landing-page-text58">Let's discuss it</span>
                  </div>
                </div>
              </div>
              <div class="landing-page-expand2">
                <div class="landing-page-overlay2">
                  <div class="landing-page-header6">
                    <div class="landing-page-heading19">
                      <span class="landing-page-text59">Expand</span>
                      <span class="landing-page-text60">
                        This is simple, no one needs to expand. In case you want
                        to partner with us, we are more than happy to discuss
                        collaboration opportunities&nbsp;
                      </span>
                    </div>
                  </div>
                  <a
                    href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Contact Form"
                    class="landing-page-link4"
                  >
                    <div class="landing-page-button6">
                      <span class="landing-page-text61">
                        <span>Contact us</span>
                        <br />
                      </span>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="landing-page-help">
            <span class="landing-page-text64">Need any help?</span>
            <div class="landing-page-explore2">
              <a
                href="mailto:surfslotpt@gmail.com?subject=SurfSlot - Contact Form"
                class="landing-page-link5"
              >
                Get in touch with us right away -&gt;
              </a>
            </div>
          </div>
        </div>
        <testimonial5-wrapper class="testimonial5-wrapper">
          <!--Testimonial5 component-->
          <div class="thq-section-padding">
            <div class="testimonial5-max-width thq-section-max-width">
              <div
                data-thq="slider"
                data-loop="true"
                data-autoplay="false"
                data-navigation="true"
                data-pagination="false"
                data-autoplay-delay="5000"
                class="testimonial5-slider swiper"
              >
                <div data-thq="slider-wrapper" class="swiper-wrapper">
                  <div
                    data-thq="slider-slide"
                    class="testimonial5-slider-slide1 swiper-slide"
                  >
                    <div class="testimonial5-container2">
                      <p class="testimonial5-text1 thq-body-large">
                        <span>
                          "It just works. Forecasts are accurate and the
                          meetings better fit my calendar and lifestyle now"
                        </span>
                      </p>
                      <div class="testimonial5-avatar1 thq-flex-row">
                        <img
                          alt="Author Avatar"
                          src="/landing/joao-gaspar-testimonial-1-200w.jpeg"
                          class="testimonial5-avatar-image1 thq-img-round thq-img-ratio-1-1"
                        />
                        <div class="testimonial5-avatar-content1">
                          <span class="testimonial5-text2 thq-body-small">
                            <span>João Gaspar</span>
                          </span>
                          <span class="testimonial5-text3 thq-body-small">
                            <span>CEO @ Finbird</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-thq="slider-slide"
                    class="testimonial5-slider-slide2 swiper-slide"
                  >
                    <div class="testimonial5-container3">
                      <p class="testimonial5-text4 thq-body-large">
                        <span>
                          "I am using surfslot on a daily basis to block my
                          calendar on the right time to go surfing. Thanks
                          guys!"
                        </span>
                      </p>
                      <div class="testimonial5-avatar2 thq-flex-row">
                        <img
                          alt="Author Avatar"
                          src="/landing/1656337063288-200h.jpeg"
                          class="testimonial5-avatar-image2 thq-img-round thq-img-ratio-1-1"
                        />
                        <div class="testimonial5-avatar-content2">
                          <span class="testimonial5-text5 thq-body-small">
                            <span>José Oliveira</span>
                          </span>
                          <span class="testimonial5-text6 thq-body-small">
                            <span>FP&amp;A @ EDPR</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    data-thq="slider-slide"
                    class="testimonial5-slider-slide3 swiper-slide"
                  >
                    <div class="testimonial5-container4">
                      <p class="testimonial5-text7 thq-body-large">
                        <span>
                          "To the ones that can't miss great sessions and also
                          have important business duties"
                        </span>
                      </p>
                      <div class="testimonial5-avatar3 thq-flex-row">
                        <img
                          alt="Author Avatar"
                          src="/landing/1539790539428-200h.jpeg"
                          class="testimonial5-avatar-image3 thq-img-round thq-img-ratio-1-1"
                        />
                        <div class="testimonial5-avatar-content3">
                          <span class="testimonial5-text8 thq-body-small">
                            <span>Gil Marques</span>
                          </span>
                          <span class="testimonial5-text9 thq-body-small">
                            <span>Founder @ Amy's Camper Vans</span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  data-thq="slider-pagination"
                  class="testimonial5-slider-pagination swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
                >
                  <div
                    data-thq="slider-pagination-bullet"
                    class="swiper-pagination-bullet swiper-pagination-bullet-active"
                  ></div>
                  <div
                    data-thq="slider-pagination-bullet"
                    class="swiper-pagination-bullet swiper-pagination-bullet-active"
                  ></div>
                  <div
                    data-thq="slider-pagination-bullet"
                    class="swiper-pagination-bullet swiper-pagination-bullet-active"
                  ></div>
                </div>
                <div
                  data-thq="slider-button-prev"
                  class="testimonial5-slider-button-prev swiper-button-prev"
                ></div>
                <div
                  data-thq="slider-button-next"
                  class="testimonial5-slider-button-next swiper-button-next"
                ></div>
              </div>
            </div>
          </div>
        </testimonial5-wrapper>
        <div id="faq" class="landing-page-faq">
          <div class="landing-page-content4">
            <div class="landing-page-header7">
              <div class="landing-page-tag3">
                <span class="landing-page-text65">
                  <span>FAQ</span>
                  <br />
                </span>
              </div>
              <div class="landing-page-heading20">
                <h2 class="landing-page-text68">Frequently Asked Questions</h2>
              </div>
            </div>
            <div class="landing-page-rows">
              <div class="landing-page-column1">
                <div class="landing-page-question1 Question">
                  <span class="landing-page-title2">
                    How does the app block time slots on my calendar?
                  </span>
                  <span class="landing-page-description4">
                    The app integrates with Google Calendar and adds surfslots
                    based on your predefined location to when there are good
                    surfing conditions based on the online surfing forecast
                    information. Other calendar software like Outlook is not
                    currently supported.&nbsp;
                  </span>
                </div>
                <div class="Question">
                  <span class="landing-page-title3">
                    Is this app free to use?
                  </span>
                  <span class="landing-page-description5">
                    The app is not free by default at this stage. We are
                    preparing a free and a business plan to provide your
                    surfslots with even more customisation.&nbsp;
                  </span>
                </div>
                <div class="landing-page-question3 Question">
                  <span class="landing-page-title4">
                    What devices is this app compatible with?
                  </span>
                  <span class="landing-page-description6">
                    The app will be available as a web app, which means that it
                    can be accessed using any device with a web browser.&nbsp;
                  </span>
                </div>
              </div>
              <div class="landing-page-column2">
                <div class="landing-page-question4 Question">
                  <span class="landing-page-title5">
                    Can I customize the app's settings?
                  </span>
                  <span class="landing-page-description7">
                    <span>
                      Yes, currently the app allows you to customise its
                      settings like location and preferred surfing spots. You
                      can choose to receive notifications when a time slot is
                      blocked or when a new surfing forecast becomes available.
                      You can also override the app's blocking time slots in
                      your calendar if you need to attend a meeting during a
                      good surfing time.
                    </span>
                    <br />
                    <span>
                      In the near future you will be able to customise your
                      skill and the periods when you prefer to surf.&nbsp;
                    </span>
                    <br />
                  </span>
                </div>
                <div class="landing-page-question5 Question">
                  <span class="landing-page-title6">
                    Where does the app get its surfing forecast information
                    from?
                  </span>
                  <span class="landing-page-description8">
                    The app sources its surfing forecast information from
                    reputable surfing websites and updates it regularly to
                    ensure accuracy.
                  </span>
                </div>
                <div class="landing-page-question6 Question">
                  <span class="landing-page-title7">
                    Does the app only work in certain locations?
                  </span>
                  <span class="landing-page-description9">
                    Yes, the app has limited locations available, and for each
                    location limited surf spots. The current available locations
                    are: Ericeira &lt;3, Lisbon, Peniche, Porto, Uluwatu,
                    Canggu, Weligama, Puerto Escondido, Santa Teresa, Santa
                    Cruz, Malibu. If you would like to use it but your surf
                    spots are not covered, feel free to reach us out.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="landing-page-get-started">
          <div class="landing-page-content5">
            <div class="landing-page-heading21">
              <h2 class="landing-page-text73">
                Get started with surfslot now!
              </h2>
            </div>
            <div class="landing-page-hero-buttons"></div>
          </div>
          <a href="/" id="google-login" class="landing-page-navlink">
            <div
              loginwithgoogle=""
              class="landing-page-android-btn2 google-login"
            >
              <caption-wrapper-c7eh class="caption-wrapper-c7eh">
                <!--Caption component-->
                <div class="caption-container1">
                  <span class="caption-caption1">
                    <span>Sign in with Google</span>
                  </span>
                </div>
              </caption-wrapper-c7eh>
              <img
                alt="image"
                src="/landing/google-logo-png-suite-everything-you-need-know-about-google-newest-0-200h.png"
                class="landing-page-image4"
              />
            </div>
          </a>
        </div>
        <footer-wrapper class="footer-wrapper">
          <!--Footer component-->
          <div class="footer-footer">
            <div class="footer-content">
              <div class="footer-information">
                <div class="footer-heading">
                  <h1 class="footer-text1"><span>surfslot</span></h1>
                  <span class="footer-surfslot">
                    <span>
                      do not lose that surf session. work might wait, the tide
                      won't
                    </span>
                  </span>
                </div>
              </div>
              <div class="footer-links"></div>
            </div>
            <span class="footer-text2">
              <span>© 2025 SurfSlot. All Rights Reserved.</span>
            </span>
          </div>
        </footer-wrapper>
        <div class="landing-page-container2">
          <a
            href="https://wa.me/00351919504155?text=Hi%20Ruben!%20I%20want%20to%20chat%20about%20surfslot!"
            target="_blank"
            rel="noreferrer noopener"
            class="landing-page-link6"
          >
            <img
              alt="image"
              src="/landing/whatsapp-icon-logo-8ca4fb831e-seeklogo.com-200h.png"
              class="landing-page-image5"
            />
          </a>
        </div>
      </div>
    </div>`;
